import { Menu, Button } from "@mantine/core";
import { BsThreeDotsVertical } from "react-icons/bs";
import { removeNote } from "../../services/note";
import { deleteTask } from "../../services/task";
import swal from "sweetalert";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteAttendanceStaff,
  getAllAttendenceStaff,
  updateAttendenceStaff,
} from "../../services/staff";
import { useSelector } from "react-redux";
import { saveAs } from "file-saver";
import moment from "moment";

function MenuDropdown({
  isNote,
  row,
  view,
  taskItem,
  isTask,
  isDashboradMode,
  startDate,
  endDate,
  isStaff,
  edit,
  disabled,
  isEdit = true,
  track,
  currentPage,
  range,
  isAttendance,
  onRemoveContractor,
  targetClassName,
}) {
  const navigate = useNavigate();
  const { profile } = useSelector((state) => state?.profile);

  const location = useLocation();

  const deleteNoteHandle = async (canDelete) => {
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });

    if (willDelete)
      removeNote(row, null, () => {}, null, null, isDashboradMode);
  };

  const deleteAttendanceHandle = async () => {
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) {
      const res = await deleteAttendanceStaff(track?._id);
      await getAllAttendenceStaff(currentPage, range);
    }
  };

  const deleteTaskHandle = async (taskId, shift) => {
    await deleteTask({ taskId, shift }, startDate, endDate);
  };

  const handleStaffManageAttendance = () => {
    navigate(`/home/staff/manage-attendance/${row?.id}`);
  };

  const getEvvRecordData = () => {
    const staffName = track?.staff?.name || `${track?.staff?.firstName || ""} ${track?.staff?.lastName || ""}`;
    const date = track?.date?.date ? moment(track.date.date).format("YYYY-MM-DD") : "unknown";
    const records = [];

    const buildRecord = (evv, event) => {
      if (!evv) return;
      records.push({
        staffName,
        date,
        clockInType: track?.checkin_type || "",
        clientName: track?.client?.name || "",
        service: track?.service || "",
        event,
        timestamp: evv.timestamp ? moment(evv.timestamp).format("YYYY-MM-DD HH:mm:ss") : "",
        lat: evv.location?.lat ?? "",
        lng: evv.location?.lng ?? "",
        accuracy: evv.location?.accuracy ?? "",
        distance: evv.distance ?? "",
        address: evv.location?.address || "",
        deviceType: evv.deviceInfo?.type || "",
        locationSource: evv.location?.source || "",
        deviceIp: evv.deviceInfo?.ip || "",
        userAgent: evv.deviceInfo?.userAgent || "",
        evvEnforced: track?.evvEnforced ? "Yes" : "No",
      });
    };

    buildRecord(track?.evvClockIn, "Clock-In");
    buildRecord(track?.evvClockOut, "Clock-Out");

    return { staffName, date, records };
  };

  const downloadEvvRecord = (format = "csv") => {
    const { staffName, date, records } = getEvvRecordData();
    const fileBase = `EVV_${staffName.replace(/\s+/g, "_")}_${date}`;

    if (format === "json") {
      const blob = new Blob([JSON.stringify(records, null, 2)], { type: "application/json;charset=utf-8" });
      saveAs(blob, `${fileBase}.json`);
      return;
    }

    if (format === "xml") {
      const escXml = (val) => String(val ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
      let xml = '<?xml version="1.0" encoding="UTF-8"?>\n<EvvRecords>\n';
      records.forEach((r) => {
        xml += "  <Record>\n";
        Object.entries(r).forEach(([key, val]) => {
          xml += `    <${key}>${escXml(val)}</${key}>\n`;
        });
        xml += "  </Record>\n";
      });
      xml += "</EvvRecords>";
      const blob = new Blob([xml], { type: "application/xml;charset=utf-8" });
      saveAs(blob, `${fileBase}.xml`);
      return;
    }

    // CSV (default)
    const headers = [
      "Staff Name", "Date", "Clock-In Type", "Client Name", "Service",
      "Event", "Timestamp", "Lat", "Lng",
      "Accuracy (m)", "Distance (mi)", "Address", "Device Type",
      "Location Source", "Device IP", "User Agent", "EVV Enforced",
    ];
    const escCsv = (val) => {
      const s = String(val ?? "");
      return s.includes(",") || s.includes('"') || s.includes("\n")
        ? `"${s.replace(/"/g, '""')}"` : s;
    };
    const rows = [headers.join(",")];
    records.forEach((r) => {
      rows.push(Object.values(r).map(escCsv).join(","));
    });
    const blob = new Blob([rows.join("\n")], { type: "text/csv;charset=utf-8" });
    saveAs(blob, `${fileBase}.csv`);
  };

  const Changestatus = async (status) => {
    try {
      let payload = [
        {
          id: track._id,
          approvedStatus: status,
        },
      ];

      let result = await updateAttendenceStaff(payload);

      await getAllAttendenceStaff(currentPage, range);
    } catch (error) {
    }
  };

  return (
    <div style={{ position: "relative", overflow: "visible" }}>
      <Menu shadow="md" width={160} withinPortal={true}>
        <Menu.Target>
          <Button variant="unstyled" className={targetClassName}>
            <BsThreeDotsVertical />
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          {/* {isNote !== true && isEdit && ( */}
              {isNote !== true && profile?.user?.role !=='staff' && (
            <Menu.Item
              onClick={() => {
                if (isTask) {
                  navigate("/home/edit-task", {
                    state: { ...row, selectedShift: taskItem },
                  });
                } else {
                  edit();
                }
              }}
              disabled={disabled}
            >
              Edit
            </Menu.Item>
          )}

          {isNote !== true && isEdit && track && (
            <Menu.Item
              onClick={() =>
                Changestatus(
                  track?.approvedStatus === "approved" ? "pending" : "approved"
                )
              }
              disabled={disabled || track?.staff?.id === profile?.user?.admin}
            >
              {track?.approvedStatus === "approved"
                ? "Mark as pending"
                : "Mark as approved"}
            </Menu.Item>
          )}

          <Menu.Item
            onClick={() => {
              if (isTask) {
                navigate("/home/view-task", {
                  state: { ...row, selectedShift: taskItem },
                });
              } else {
                view();
              }
            }}
          >
            View
          </Menu.Item>

          {isAttendance && (track?.evvClockIn || track?.evvClockOut) && (
            <>
              <Menu.Item onClick={() => downloadEvvRecord("csv")}>
                Download EVV (CSV)
              </Menu.Item>
              <Menu.Item onClick={() => downloadEvvRecord("json")}>
                Download EVV (JSON)
              </Menu.Item>
              <Menu.Item onClick={() => downloadEvvRecord("xml")}>
                Download EVV (XML)
              </Menu.Item>
            </>
          )}

          {isStaff && (
            <Menu.Item
              onClick={() => {
                handleStaffManageAttendance();
              }}
            >
              Manage Attendance
            </Menu.Item>
          )}

          {isStaff && onRemoveContractor && row?.role?.toLowerCase() === "contractor" && (
            <Menu.Item
              color="red"
              onClick={async () => {
                const willRemove = await swal({
                  title: "Remove Contractor?",
                  text: "This will unlink the contractor from your account. This action cannot be undone.",
                  icon: "warning",
                  dangerMode: true,
                  buttons: ["Cancel", "Remove"],
                });
                if (willRemove) {
                  onRemoveContractor(row?.id);
                }
              }}
            >
              Remove Contractor
            </Menu.Item>
          )}

          {!isStaff && profile?.user?.role !=='staff' && (
            <Menu.Item
              onClick={() => {
                if (isTask) {
                  deleteTaskHandle(row?.id, taskItem);
                } else if (isAttendance) {
                  deleteAttendanceHandle();
                } else {
                  deleteNoteHandle();
                }
              }}
            >
              Delete
            </Menu.Item>
          )}
        </Menu.Dropdown>
      </Menu>
    </div>
  );
}
export default MenuDropdown;
